import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import { 
  showModalContent, 
  hideModalContent 
} from '../helpers/functions';

export default function ReusableModal({ width, height, top, left, interactionsWidth, interactionsHeight, children }) { 
  const [show, setShow] = useState(false);

  return (
    <>
      <button 
        onClick={() => setShow(true)}
        className="position-absolute"
        style={{
          width: width, 
          height: height, 
          top: top, 
          left: left,
          cursor: 'pointer'
        }}
      />
      <Modal
        size="xl"
        centered
        show={show}
        onShow={() => setShow(true)}
        onHide={() => setShow(false)}
        contentClassName="m-auto w-100"
        onEntered={showModalContent}
        onExit={hideModalContent}
        dialogClassName="custom-modal-dialog"
        style={{
          '--interactions-width': interactionsWidth,
          '--interactions-height': interactionsHeight
        }}
      >
        <Modal.Body
          onClick={() => setShow(false)}
        >
          {children}
        </Modal.Body>
      </Modal>
    </>
  )
}
